import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=772b7b08"
import script from "../../services/layout/header.js?vue&type=script&lang=js&external"
export * from "../../services/layout/header.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/components/layout/header.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports